import { render } from "./pageTitle.vue?vue&type=template&id=08816bfc&scoped=true"
import script from "./pageTitle.vue?vue&type=script&lang=js"
export * from "./pageTitle.vue?vue&type=script&lang=js"

import "./pageTitle.vue?vue&type=style&index=0&id=08816bfc&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08816bfc"]])

export default __exports__